import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import text from 'styles/utility/text.module.scss'
import format from 'date-fns/format'
import classNames from 'classnames'
import { MessageType as BaseMessageType } from 'types/message'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { FirebaseDocRefType } from 'firebase'

type MessageType = BaseMessageType & { ref: FirebaseDocRefType }

type Props = {
  messages: MessageType[]
  isAdminNotification: boolean
}

const MessageList: FC<Props> = (props) => {
  const { messages, isAdminNotification } = props
  const dispatch = useDispatch()

  return (
    <ul className={styles.message__list}>
      {messages.map((message, index) => (
        <li
          key={index}
          className={styles.message__inner}
          onClick={() =>
            isAdminNotification
              ? dispatch(push(`/admin/push_notification/${message.ref.id}`))
              : dispatch(push(`/customer/message/${message.ref.id}`))
          }
        >
          <div className={styles.message__label}>
            <p className={classNames(text.font_bold, text.font_medium, text.color_blue_main)}>{message.title}</p>
            {message.publish_status === '0' && (
              <div>
                <p className={text.font_small}>
                  配信予定日：{format(message.send_time.toDate(), 'yyyy年MM月dd日 HH:mm')}
                </p>
                <p className={text.font_small}>
                  配信予定人数：{message.user_ids?.length ? `${message.user_ids.length}人` : '全体'}
                </p>
                <p className={text.font_small}>
                  ステータス：<span className={classNames(text.font_bold, text.color_grey_01)}>下書き</span>
                </p>
              </div>
            )}
            {message.publish_status === '1' && (
              <div>
                <p className={text.font_small}>
                  配信予定日：{format(message.send_time.toDate(), 'yyyy年MM月dd日 HH:mm')}
                </p>
                <p className={text.font_small}>
                  配信予定人数：{message.user_ids?.length ? `${message.user_ids.length}人` : '全体'}
                </p>
                <p className={text.font_small}>
                  ステータス：<span className={classNames(text.font_bold, text.color_red_main)}>配信予約中</span>
                </p>
              </div>
            )}
            {message.publish_status === '2' && (
              <div>
                <p className={text.font_small}>配信日：{format(message.send_time.toDate(), 'yyyy年MM月dd日 HH:mm')}</p>
                <p className={text.font_small}>
                  配信人数：{message.user_ids?.length ? `${message.user_ids.length}人` : '全体'}
                </p>
                <p className={text.font_small}>
                  ステータス：<span className={classNames(text.font_bold, text.color_grey_01)}>配信済</span>
                </p>
              </div>
            )}
          </div>
        </li>
      ))}
    </ul>
  )
}

export default MessageList
